module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcomeView"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('h3', [_vm._v("项目管理")]), _vm._v(" "), _c('div', {
    staticClass: "title-box"
  }, _vm._l((_vm.ProjectManagementList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "content"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "value",
      on: {
        "click": function($event) {
          _vm.Skip(item.img.split('xmgl-')[1].split('.')[0])
        }
      }
    }, [_c('div', {
      staticClass: "number"
    }, [_vm._v(_vm._s(item.count) + "个")]), _vm._v(" "), _c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n            " + _vm._s(_vm.username) + " 您好，欢迎使用新美云平台！\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("当前时间：" + _vm._s(_vm.$root.formatDate(_vm.time)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('h3', [_vm._v("审批管理")]), _vm._v(" "), _c('div', {
    staticClass: "center-box"
  }, [_c('div', {
    staticClass: "left-box"
  }, [_c('div', {
    staticClass: "one-box"
  }, [_c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "bubble",
    on: {
      "click": function($event) {
        _vm.activeName = 'Wait'
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.Newstotal >= 100 ? "99+" : _vm.Newstotal) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bubble1",
    on: {
      "click": function($event) {
        _vm.activeName = 'Send'
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.CopyNewtotal >= 100 ? "99+" : _vm.CopyNewtotal) + "\n            ")]), _vm._v(" "), [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "待办",
      "name": "Wait"
    }
  }, [_c('welcomeViewApproveVue', {
    attrs: {
      "WaitList": _vm.NewsList
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "抄送我",
      "name": "Send"
    }
  }, [_c('welcomeViewApproveVue', {
    attrs: {
      "WaitList": _vm.CopyNewsList
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已发起",
      "name": "initiate"
    }
  })], 1)]], 2), _vm._v(" "), _c('div', {
    staticClass: "request"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "centerBOX"
  }, _vm._l((_vm.requestList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "value",
      on: {
        "click": function($event) {
          _vm.SkipAdd(item.src.split('fqsq-')[1].split('.')[0])
        }
      }
    }, [_c('div', {
      staticClass: "centerIcon"
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "src": item.src,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "centerName"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _vm._v(" "), _c('h3', [_vm._v("我的应用")]), _vm._v(" "), _c('div', {
    staticClass: "two-box"
  }, _vm._l((_vm.SkipList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "content",
      on: {
        "click": function($event) {
          _vm.Skip(item.src.split('app-')[1].split('.')[0])
        }
      }
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "src": item.src,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [
    [_c('el-tabs', {
      on: {
        "tab-click": _vm.handleClick1
      },
      model: {
        value: (_vm.activeName1),
        callback: function($$v) {
          _vm.activeName1 = $$v
        },
        expression: "activeName1"
      }
    }, [_c('el-tab-pane', {
      attrs: {
        "label": "公告通知",
        "name": "message",
        "lazy": ""
      }
    }, [_c('welcomeViewModulesVue', {
      attrs: {
        "institutionList": _vm.COMP_NOTICELIST
      }
    })], 1), _vm._v(" "), _c('el-tab-pane', {
      attrs: {
        "label": "公司新闻",
        "name": "news",
        "lazy": ""
      }
    }, [_c('welcomeViewModulesVue', {
      attrs: {
        "institutionList": _vm.COMP_NEWSLIST
      }
    })], 1), _vm._v(" "), _c('el-tab-pane', {
      attrs: {
        "label": "制度公告",
        "name": "announcement",
        "lazy": ""
      }
    }, [_c('welcomeViewModulesVue', {
      attrs: {
        "institutionList": _vm.COMP_INSTLIST
      }
    })], 1)], 1)]
  ], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/faqishenqing_30x30.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("发起申请")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e507331"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/welcomeView.vue
// module id = 1662
// module chunks = 471